import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { ModerationCard } from "../components/ModerationCard";

const TABS = [
  ["pending", "In attesa"],
  ["approved", "Approvati"],
  ["rejected", "Rifiutati"],
];

const Moderation = () => {
  const [status, setStatus] = useState("pending");
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api.get("/admin/posts", { params: { status } })
      .then(({ data }) => setPosts(data))
      .catch((err) => toast.error(formatApiError(err)))
      .finally(() => setLoading(false));
  }, [status]);

  useEffect(() => {
    load();
  }, [load]);

  const moderate = async (post, action, reason = "") => {
    try {
      await api.post(`/admin/posts/${post.post_id}/moderate`, { action, reason });
      toast.success(action === "approve" ? `${post.dog_name} pubblicato in galleria!` : "Ricordo rifiutato: la famiglia riceverà un'email gentile.");
      setPosts((prev) => prev.filter((p) => p.post_id !== post.post_id));
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <main className="mx-auto max-w-6xl px-4 py-14 sm:px-8 sm:py-20">
      <p className="eyebrow flex items-center gap-3">
        <span className="inline-block h-px w-8 bg-[#B85328]" />
        Area fondatori
      </p>
      <h1 data-testid="moderation-heading" className="font-display mt-4 flex items-center gap-3 text-3xl font-semibold text-[#2C2723] sm:text-4xl lg:text-5xl">
        <ShieldCheck className="text-[#4A6B5D]" size={36} />
        Moderazione dei <span className="italic text-[#B85328]">ricordi</span>
      </h1>
      <p className="mt-4 max-w-xl text-sm leading-relaxed text-[#8C7B6E]">
        Approva le foto e i video inviati dalle famiglie: solo i ricordi approvati appaiono nella galleria pubblica.
      </p>

      <div className="mt-10 flex gap-2">
        {TABS.map(([key, label]) => (
          <button
            key={key}
            data-testid={`moderation-tab-${key}`}
            onClick={() => setStatus(key)}
            className={`rounded-full px-5 py-2.5 text-xs font-semibold transition-all duration-300 ${
              status === key
                ? "bg-[#1F1A17] text-[#FBF8F3]"
                : "border border-[#CFC0B2] text-[#5C534B] hover:border-[#B85328] hover:text-[#B85328]"
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="py-20 text-center font-display text-2xl italic text-[#8C7B6E]">Caricamento...</p>
      ) : posts.length === 0 ? (
        <div data-testid="moderation-empty" className="mt-8 rounded-3xl border border-dashed border-[#CFC0B2] py-20 text-center">
          <p className="font-display text-2xl italic text-[#5C534B]">Nessun ricordo in questa lista.</p>
        </div>
      ) : (
        <div data-testid="moderation-grid" className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {posts.map((post) => (
            <ModerationCard key={post.post_id} post={post} status={status} onModerate={moderate} />
          ))}
        </div>
      )}
    </main>
  );
};

export default Moderation;
